/* Kukkiri — duas garantias no bloco de compra:
   1) nunca deixar as barras sem nenhuma escolhida (senão o cliente leva 1 frasco
      depois de ler a página inteira sobre o kit maior);
   2) o preço dentro do botão sempre igual ao da barra escolhida. */
(function () {
  'use strict';
  var PADRAO = 1;   // índice da barra pré-escolhida (0 = primeira). 1 = a do meio.

  function barras() {
    return [].slice.call(document.querySelectorAll('.kaching-bundles__bar'));
  }
  function escolhida() {
    var bs = barras();
    for (var i = 0; i < bs.length; i++) {
      var r = bs[i].querySelector('input[type="radio"]');
      if ((r && r.checked) || /selected|active|is-checked/i.test(bs[i].className)) return bs[i];
    }
    return null;
  }
  function garantirEscolha() {
    var bs = barras();
    if (!bs.length || escolhida()) return false;
    var alvo = bs[Math.min(PADRAO, bs.length - 1)];
    var radio = alvo.querySelector('input[type="radio"]');
    var rotulo = alvo.querySelector('label') || alvo;
    // o app é Vue: clicar na div não faz nada — o alvo real é o radio ou o label
    if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); radio.click(); }
    else if (rotulo) rotulo.click();
    return true;
  }
  function sincronizarPreco() {
    var alvo = document.querySelector('.kk-cta__preco');
    if (!alvo) return;
    var b = escolhida(); if (!b) return;
    // ler os elementos de preço do app, nunca o texto inteiro da barra:
    // a etiqueta "¥19,940おトク" (economia) vem ANTES do preço e enganava o regex
    var elPreco = b.querySelector('.kaching-bundles__bar-price');
    var elRisco = b.querySelector('.kaching-bundles__bar-full-price');
    var preco = elPreco ? (elPreco.textContent || '').trim() : '';
    if (!preco) return;
    alvo.textContent = preco;
    var risco = document.querySelector('.kk-cta__risco');
    if (risco) {
      var r = elRisco ? (elRisco.textContent || '').trim() : '';
      risco.textContent = (r && r !== preco) ? r : '';
      risco.style.display = risco.textContent ? '' : 'none';
    }
  }
  function passo() { garantirEscolha(); sincronizarPreco(); }
  function ligar() {
    passo();
    var bloco = document.querySelector('.kaching-bundles, [class*="kaching-bundles"]');
    if (bloco && window.MutationObserver) {
      new MutationObserver(function () { sincronizarPreco(); })
        .observe(bloco, { subtree: true, childList: true, attributes: true, characterData: true });
    }
    document.addEventListener('change', sincronizarPreco, true);
    document.addEventListener('click', function () { setTimeout(sincronizarPreco, 60); }, true);
    // o app hidrata em etapas: reconferimos algumas vezes
    [400, 1200, 2500, 4000].forEach(function (t) { setTimeout(passo, t); });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', ligar) : ligar();
  document.addEventListener('shopify:section:load', ligar);
})();
